import { createAuth0 } from '@auth0/auth0-vue';
import * as Sentry from '@sentry/vue';
import axios from 'axios';
import { createApp } from 'vue';
import { createPinia } from 'pinia';
import App from './App.vue';
import router from './router';
import { setAuth0Instance } from './api/client';

// Check if we're on callback with errors before initializing Auth0
const urlParams = new URLSearchParams(window.location.search);
const hasCallbackError = urlParams.has('error') && window.location.pathname === '/callback';

console.log('Callback error detected:', hasCallbackError);

// If we have callback errors, strip the parameters that trigger Auth0's automatic processing
if (hasCallbackError) {
  const url = new URL(window.location.href);
  url.searchParams.delete('state');
  url.searchParams.delete('code');
  url.searchParams.delete('iss');
  // Keep error and error_description for the component to display

  // Update URL without triggering a page reload
  window.history.replaceState({}, '', url.toString());
  console.log('Stripped callback parameters to prevent automatic processing');
}

const auth0Plugin = createAuth0({
  domain: import.meta.env.VITE_AUTH0_DOMAIN,
  clientId: import.meta.env.VITE_AUTH0_CLIENT_ID,
  authorizationParams: {
    audience: import.meta.env.VITE_AUTH0_AUDIENCE,
    redirect_uri: window.location.origin + '/callback',
    scope: 'openid profile email',
  },
});

// Set Auth0 instance for openapi-fetch client
setAuth0Instance(auth0Plugin);

// Axios defaults
axios.defaults.baseURL = import.meta.env.VITE_API_URL;

// Authentication interceptor for axios
axios.interceptors.request.use(async (config) => {
  const token = await auth0Plugin.getAccessTokenSilently();
  if (!token) {
    return config;
  }
  config.headers.Authorization = `Bearer ${token}`;
  return config;
});

const app = createApp(App);

Sentry.init({
  app,
  dsn: 'https://289249013163b6d0b9963819d7703ad4@o4510714525319169.ingest.de.sentry.io/4510714922467408',
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
  integrations: [
    Sentry.replayIntegration({
      maskAllText: false,
    }),
  ],
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

app.use(createPinia()).use(router).use(auth0Plugin);

app.mount('#app');
